<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">TEST</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <live-streaming-player :source="live_streaming_url"></live-streaming-player>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import LiveStreamingPlayer from '@/components/players/LiveStreamingPlayer'

export default {
  name: "test",
  data() {
      return {
        live_streaming_url: 'https://60.244.109.123:1936/live/12f_pad/playlist.m3u8'
      }
  },
  methods: {
    // 
  },
  created() {
    //alert(`Vue version : ${Vue.version}`)
  },
  components: {
    LiveStreamingPlayer
  }
}
</script>